import { AnalyticsEventName } from '../types/analytics';

export const EventSchemas: Partial<
  Record<
    AnalyticsEventName,
    {
      description: string;
      properties: Record<
        string,
        {
          type: string;
          description: string;
          required?: boolean;
        }
      >;
    }
  >
> = {
  'Page Viewed': {
    description: 'User viewed a page',
    properties: {
      path: {
        type: 'string',
        description: 'URL path of the page',
        required: true,
      },
      title: {
        type: 'string',
        description: 'Title of the page',
        required: true,
      },
      referrer: { type: 'string', description: 'Previous page URL' },
    },
  },

  'Button Clicked': {
    description: 'User clicked a button',
    properties: {
      buttonId: {
        type: 'string',
        description: 'Unique identifier for the button',
        required: true,
      },
      buttonText: {
        type: 'string',
        description: 'Text displayed on the button',
        required: true,
      },
      buttonType: {
        type: 'string',
        description: 'Type of button (primary, secondary, etc.)',
      },
    },
  },

  'Form Submitted': {
    description: 'User submitted a form',
    properties: {
      formId: {
        type: 'string',
        description: 'Unique identifier for the form',
        required: true,
      },
      formName: {
        type: 'string',
        description: 'Name of the form',
        required: true,
      },
      success: {
        type: 'boolean',
        description: 'Whether the submission was successful',
        required: true,
      },
      errorMessage: {
        type: 'string',
        description: 'Error message if submission failed',
      },
    },
  },

  'User Created': {
    description: 'New user account created',
    properties: {
      signupMethod: {
        type: 'string',
        description: 'Method used for signup (email, google, etc.)',
        required: true,
      },
      email: {
        type: 'string',
        description: 'User email address',
        required: true,
      },
    },
  },

  'Error Experienced': {
    description: 'An error occurred',
    properties: {
      error: { type: 'string', description: 'Error message' },
      context: { type: 'string', description: 'Context of the error' },
      message: { type: 'string', description: 'Error message' },
    },
  },
};
